import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { api } from "services/api.service";
import { PickupTrackingResponse } from "types/pickupTracking";

const POLL_INTERVAL_MS = 30_000;

export default function usePickupTracking() {
  const { pickupUuid } = useParams<{ pickupUuid: string }>();

  return useQuery(
    ["pickupTracking", pickupUuid],
    () =>
      api
        .get<PickupTrackingResponse>(`/pickups/${pickupUuid}/tracking`)
        .then((res) => res.data),
    {
      enabled: Boolean(pickupUuid),
      refetchInterval: POLL_INTERVAL_MS,
      refetchIntervalInBackground: false,
    }
  );
}
